/* eslint-disable no-underscore-dangle */
import { isEmpty } from '@springbokagency/stencil-base';

export default function pageTracking(language: string, subCategory3: string): void {
  if (!isEmpty(window._satellite)) {
    window._satellite.track('trackView', {
      siteCategory: 'b2c',
      language,
      pageType: 'campaign-page',
      primaryCategory: 'multi',
      subCategory1: 'multi',
      subCategory2: 'first-timers',
      subCategory3,
    });
  }
}
